import { Select } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useInsurerReportsStore } from "store/InsurerReportsStore";

type Props = {
  name: string;
  required?: boolean;
  disabled?: boolean;
  value?: any;
  visible?: boolean;
  isLoading: boolean;
  onBlur?: (e: any) => void;
};

export const SearchDateFilterField = ({
  name,
  required = false,
  disabled = false,
  visible,
  isLoading,
  onBlur = null,
}: Props) => {
  const { t } = useTranslation();
  const [{ searchDateFilterField }, { setInsurerReportsStoreValue }] =
    useInsurerReportsStore();

  if (!visible) return null;
  return (
    <>
      <Select
        data-help="insurer-reports-date-field"
        required={required}
        disabled={disabled || isLoading}
        id={name}
        name={"searchDateFilterField"}
        onBlur={(e) => {
          onBlur && onBlur(e);
        }}
        onChange={(e, data) => {
          setInsurerReportsStoreValue("searchDateFilterField", data.value);
        }}
        value={searchDateFilterField || ""}
        title={t("pct.taxonomy.selectTitle.label")}
      >
        <option key={"insurerReportDate"} value={"insurerReportDate"}>
          {t("pct.insurerReportDate.label")}
        </option>
        <option
          key={"insurerReportCreatedAt"}
          value={"insurerReportCreatedAt"}
        >
          {t("pct.insurerReportCreatedAt.label")}
        </option>
      </Select>
    </>
  );
};

export default SearchDateFilterField;
